import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Users, TrendingUp, Clock, Globe } from "lucide-react";

interface WebsiteData {
  id: string;
  domain: string;
  title: string;
  favicon_url: string;
}

interface VisitorsTabProps {
  website: WebsiteData;
}

export function VisitorsTab({ website }: VisitorsTabProps) {
  return (
    <div className="p-6 space-y-8">
      {/* Header */}
      <div className="flex justify-between items-center">
        <div>
          <h2 className="text-3xl font-bold text-foreground">Visitors</h2>
          <p className="text-muted-foreground">Track and analyze your website traffic and visitor behavior</p>
        </div>
      </div>

      {/* Coming Soon Cards */}
      <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
        <Card className="border-dashed opacity-60">
          <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
            <CardTitle className="text-sm font-medium">Total Visitors</CardTitle>
            <Users className="h-4 w-4 text-muted-foreground" />
          </CardHeader>
          <CardContent>
            <div className="text-2xl font-bold text-muted-foreground">---</div>
            <p className="text-xs text-muted-foreground">Coming soon</p>
          </CardContent>
        </Card>

        <Card className="border-dashed opacity-60">
          <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
            <CardTitle className="text-sm font-medium">Page Views</CardTitle>
            <Globe className="h-4 w-4 text-muted-foreground" />
          </CardHeader>
          <CardContent>
            <div className="text-2xl font-bold text-muted-foreground">---</div>
            <p className="text-xs text-muted-foreground">Coming soon</p>
          </CardContent>
        </Card>

        <Card className="border-dashed opacity-60">
          <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
            <CardTitle className="text-sm font-medium">Avg. Session</CardTitle>
            <Clock className="h-4 w-4 text-muted-foreground" />
          </CardHeader>
          <CardContent>
            <div className="text-2xl font-bold text-muted-foreground">---</div>
            <p className="text-xs text-muted-foreground">Coming soon</p>
          </CardContent>
        </Card>

        <Card className="border-dashed opacity-60">
          <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
            <CardTitle className="text-sm font-medium">Bounce Rate</CardTitle>
            <TrendingUp className="h-4 w-4 text-muted-foreground" />
          </CardHeader>
          <CardContent>
            <div className="text-2xl font-bold text-muted-foreground">---%</div>
            <p className="text-xs text-muted-foreground">Coming soon</p>
          </CardContent>
        </Card>
      </div>

      {/* Main Coming Soon Card */}
      <Card className="border-dashed">
        <CardContent className="text-center py-16">
          <div className="max-w-md mx-auto">
            <div className="w-20 h-20 mx-auto mb-6 rounded-full bg-primary/10 flex items-center justify-center">
              <Users className="h-10 w-10 text-primary opacity-70" />
            </div>
            <h3 className="text-2xl font-bold text-foreground mb-4">Visitor Analytics Coming Soon</h3>
            <p className="text-muted-foreground mb-6 leading-relaxed">
              We're building comprehensive visitor analytics to help you understand your audience better. 
              Track page views, user behavior, traffic sources, and more with detailed insights and reports.
            </p>
            
            <div className="space-y-3 text-left max-w-sm mx-auto mb-8">
              <div className="flex items-center gap-3 text-sm text-muted-foreground">
                <div className="w-2 h-2 rounded-full bg-primary"></div>
                Real-time visitor tracking
              </div>
              <div className="flex items-center gap-3 text-sm text-muted-foreground">
                <div className="w-2 h-2 rounded-full bg-primary"></div>
                Traffic source analysis
              </div>
              <div className="flex items-center gap-3 text-sm text-muted-foreground">
                <div className="w-2 h-2 rounded-full bg-primary"></div>
                Page performance metrics
              </div>
              <div className="flex items-center gap-3 text-sm text-muted-foreground">
                <div className="w-2 h-2 rounded-full bg-primary"></div>
                User behavior insights
              </div>
              <div className="flex items-center gap-3 text-sm text-muted-foreground">
                <div className="w-2 h-2 rounded-full bg-primary"></div>
                Custom dashboard widgets
              </div>
            </div>

            <div className="space-y-3">
              <Button disabled className="px-8">
                Enable Visitor Tracking (Coming Soon)
              </Button>
              <p className="text-xs text-muted-foreground">
                Get notified when this feature becomes available
              </p>
            </div>
          </div>
        </CardContent>
      </Card>

      {/* Feature Preview */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <Card className="border-dashed opacity-60">
          <CardHeader>
            <CardTitle className="text-muted-foreground">Traffic Sources</CardTitle>
          </CardHeader>
          <CardContent className="h-48 flex items-center justify-center">
            <p className="text-muted-foreground">Chart preview coming soon</p>
          </CardContent>
        </Card>

        <Card className="border-dashed opacity-60">
          <CardHeader>
            <CardTitle className="text-muted-foreground">Top Pages</CardTitle>
          </CardHeader>
          <CardContent className="h-48 flex items-center justify-center">
            <p className="text-muted-foreground">Page analytics coming soon</p>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}